import React from "react";

const PollManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.256"
      height="46.838"
      viewBox="0 0 43.256 46.838"
    >
      <g id="db81" transform="translate(-167.983 -151.052)">
        <path
          id="Path_1754"
          data-name="Path 1754"
          d="M196.807,304.612l1.133-3.054a.99.99,0,0,0-.936-1.33H175.53a6.642,6.642,0,0,0-6.649,6.009l-.887,8.176a1.6,1.6,0,0,0,1.231,1.724c.886.2,2.069.345,3.251.492l.739,13a2.054,2.054,0,0,0,2.069,1.921h6.255a2.089,2.089,0,0,0,2.069-1.921l1.083-22.311a2.028,2.028,0,0,1,2.019-2.019h9.112a1.09,1.09,0,0,0,.985-.689Z"
          transform="translate(0 -133.662)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1755"
          data-name="Path 1755"
          d="M216.836,157.9a6.846,6.846,0,1,1-6.846-6.846,6.846,6.846,0,0,1,6.846,6.846"
          transform="translate(-31.504)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1756"
          data-name="Path 1756"
          d="M476.987,306.317h3a.569.569,0,0,0,.591-.591v-4.433a.569.569,0,0,0-.591-.591h-3a.569.569,0,0,0-.591.591v4.433A.569.569,0,0,0,476.987,306.317Z"
          transform="translate(-276.339 -134.086)"
          fill={fill ? fill : "#43e57a"}
        />
        <path
          id="Path_1757"
          data-name="Path 1757"
          d="M425.551,372.685H410.922a1.766,1.766,0,0,0-1.773,1.773v21.08a.883.883,0,0,0,.886.886H412.6a.883.883,0,0,0,.886-.886v-6.157h9.506v6.157a.883.883,0,0,0,.886.886h2.561a.883.883,0,0,0,.886-.886V374.457a1.765,1.765,0,0,0-1.773-1.773Zm-2.955,7.043-4.531,4.531a1.308,1.308,0,0,1-1.871,0l-2.315-2.364a1.323,1.323,0,0,1,1.872-1.872l1.428,1.428,3.6-3.6a1.37,1.37,0,0,1,1.872,0,1.323,1.323,0,0,1-.049,1.872Z"
          transform="translate(-216.085 -198.582)"
          fill={fill ? fill : "#43e57a"}
        />
      </g>
    </svg>
  );
};

export default PollManagementIcon;
